import { lazy } from 'react';

export const CreateObjectPage = lazy(() =>
  import('./ui/CreateObjectPage').then((module) => ({
    default: module.CreateObjectPage,
  }))
);
